import { render, staticRenderFns } from "./DictModal.vue?vue&type=template&id=382732a9&"
import script from "./DictModal.vue?vue&type=script&lang=js&"
export * from "./DictModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('382732a9')) {
      api.createRecord('382732a9', component.options)
    } else {
      api.reload('382732a9', component.options)
    }
    module.hot.accept("./DictModal.vue?vue&type=template&id=382732a9&", function () {
      api.rerender('382732a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DictModal.vue"
export default component.exports